import { useAppDispatch, useAppSelector } from '@/app/hooks';
import { AppState } from '@/app/store';
import { Menu, Transition } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/solid';
import classnames from 'classnames';
import useTranslation from 'next-translate/useTranslation';
import { Fragment } from 'react';
import { setOrderOptions } from './productsFilterSlice';

export function SortFilter() {
  const dispatch = useAppDispatch();
  const form = useAppSelector((state: AppState) => state.productFilter);
  const { t } = useTranslation();
  const sortOptions = [
    {
      name: t('common:Newest uploads'),
      sort: () => {
        dispatch(setOrderOptions({ order: 'desc', order_by: 'created' }));
      },
      current: form.order == 'desc' && form.order_by == 'created',
    },
    {
      name: t('common:Oldest uploads'),
      sort: () => {
        dispatch(setOrderOptions({ order: 'asc', order_by: 'created' }));
      },
      current: form.order == 'asc' && form.order_by == 'created',
    },
    {
      name: t('common:Newest machines'),
      sort: () => {
        dispatch(setOrderOptions({ order: 'desc', order_by: 'year' }));
      },
      current: form.order == 'desc' && form.order_by == 'year',
    },
    {
      name: t('common:Oldest machines'),
      sort: () => {
        dispatch(setOrderOptions({ order: 'asc', order_by: 'year' }));
      },
      current: form.order == 'asc' && form.order_by == 'year',
    },
    {
      name: t('common:Price: Low to High'),
      sort: () => {
        dispatch(setOrderOptions({ order: 'asc', order_by: 'price' }));
      },
      current: form.order == 'asc' && form.order_by == 'price',
    },
    {
      name: t('common:Price: High to Low'),
      sort: () => {
        dispatch(setOrderOptions({ order: 'desc', order_by: 'price' }));
      },
      current: form.order == 'desc' && form.order_by == 'price',
    },
  ];
  return (
    <Menu as='div' className='relative ml-12 inline-block text-left'>
      <div>
        <Menu.Button className='group inline-flex justify-center text-sm font-medium text-gray-700 hover:text-gray-900'>
          <>
            {t('common:Sort')}
            <ChevronDownIcon
              className='-mr-1 ml-1 h-5 w-5 flex-shrink-0 text-gray-400 group-hover:text-gray-500'
              aria-hidden='true'
            />
          </>
        </Menu.Button>
      </div>

      <Transition
        as={Fragment}
        enter='transition ease-out duration-100'
        enterFrom='transform opacity-0 scale-95'
        enterTo='transform opacity-100 scale-100'
        leave='transition ease-in duration-75'
        leaveFrom='transform opacity-100 scale-100'
        leaveTo='transform opacity-0 scale-95'
      >
        <Menu.Items className='absolute right-0 mt-2 w-40 origin-top-right rounded-md bg-white shadow-2xl ring-1 ring-black ring-opacity-5 focus:outline-none'>
          <div className='py-1'>
            {sortOptions.map((option) => (
              <Menu.Item key={option.name}>
                {({ active }) => (
                  <div
                    onClick={option.sort}
                    className={classnames({
                      'block cursor-pointer px-4 py-2 text-sm': true,
                      'font-medium text-gray-900': option.current,
                      'text-gray-500': !option.current,
                      'bg-gray-100': active,
                    })}
                  >
                    {option.name}
                  </div>
                )}
              </Menu.Item>
            ))}
          </div>
        </Menu.Items>
      </Transition>
    </Menu>
  );
}
